<img
    ngSrcset="1x, 2x, 3x"
    [placeholder]="placeholder"
    [placeholderConfig]="{ blur: false }"
    [ngSrc]="error ? placeholder : image"
    [width]="24"
    [height]="24"
    (error)="loadingError()" />
